/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Column_Transaction_CodeInputs */

const en_case_payment_column_transaction_code = /** @type {(inputs: Case_Payment_Column_Transaction_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transaction code`)
};

const pt_br2_case_payment_column_transaction_code = /** @type {(inputs: Case_Payment_Column_Transaction_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código da transação`)
};

/**
* | output |
* | --- |
* | "Transaction code" |
*
* @param {Case_Payment_Column_Transaction_CodeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_column_transaction_code = /** @type {((inputs?: Case_Payment_Column_Transaction_CodeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Column_Transaction_CodeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_column_transaction_code(inputs)
	return pt_br2_case_payment_column_transaction_code(inputs)
});